<template>
  <v-card>
    <AgrButton
      class="float-right pt-2"
      icon
      @click="cancel"
    >
      <v-icon>mdi-close</v-icon>
    </AgrButton>
    <v-card-text class="primary--text pa-5 text-h4">
      {{ title }}
    </v-card-text>

    <v-card-text class="subtitle-1">
      <slot />
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        :disabled="loading"
        @click="cancel"
      >
        {{ cancelText }}
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :loading="loading"
        @click="confirm"
      >
        {{ confirmText }}
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'ConfirmModal',
  components: { AgrButton },
  props: {
    title: {
      type: String,
      default: 'Confirmation'
    },
    cancelText: {
      type: String,
      default: 'Annuler'
    },
    confirmText: {
      type: String,
      default: 'Valider'
    },
    loading: {
      type: Boolean,
        default: false
    }
  },

  methods: {
    cancel () {
      this.$emit('cancel')
    },

    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card .AgrButton__content {
  display: block;
  width: 100%;
  flex: none;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
</style>
